<template>
    <div id="Financial_Top">
        <div>
            <div>
                <!--        面包屑-->
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item>第三方列表</el-breadcrumb-item>
                </el-breadcrumb>
                <!--        面包屑 end-->
                <!--        内容-->
                <el-card>
                    <el-form ref="form" :model="searchForm" label-width="80px" :inline="true" size="small">
                        <el-form-item label="">
                            <el-input v-model="searchForm.user_id" placeholder="请输入用户ID"></el-input>
                        </el-form-item>
                        <el-form-item label="">
                            <el-input v-model="searchForm.nickname" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                        <el-form-item label="">
                            <el-select v-model="searchForm.type" placeholder="请选择类型" clearable>
                                <el-option label="微信" value="weixin"></el-option>
                                <el-option label="QQ" value="qq"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="search">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                            :data="tableData"
                            border
                            size="small"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                width="100"
                                label="序号">
                        </el-table-column>
                        <el-table-column
                                prop="isyear"
                                label="用户头像">
                            <template slot-scope="scope">
                                <img :src="scope.row.userInfo.avatar" alt="" width="30" height="30">
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="user_id"
                                label="用户id">
                        </el-table-column>
                        <el-table-column
                                prop="nickname"
                                label="用户名称">
                        </el-table-column>
                        <el-table-column
                                prop="bind_time"
                                label="绑定时间">
                        </el-table-column>
                        <el-table-column
                                prop="unbind_time"
                                label="解绑时间">
                        </el-table-column>
                        <el-table-column
                                prop="type"
                                label="类型">
                            <template slot-scope="scope">
                                <span v-if="scope.row.type=='weixin'">微信</span>
                                <span v-if="scope.row.type=='qq'">QQ</span>
                                <span v-if="scope.row.type=='weibo'">微博</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="el-pagination">
                        <el-pagination
                                background
                                @size-change="changeSize"
                                @current-change="changeCurrent"
                                :current-page="params.pagenum"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="params.pagesize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="params.totals">
                        </el-pagination>
                    </div>

                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    import {formatDate} from '../../utils/common'

    export default {
        name: "Financial_Top",
        data() {
            return {
                params: {
                    pagenum: 1,
                    pagesize: 10,
                    totals: 0,
                },
                form: {
                    time1: '',
                    time2: ''
                },
                tableData: [],
                fromTitle: '',
                visible: false,
                imageUrl: '',
                searchForm: {
                    user_id: '',
                    nickname: '',
                    type: ''
                }
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                let data = {
                    page: this.params.pagenum,
                    page_size: this.params.pagesize,
                    user_id: this.searchForm.user_id,
                    nickname: this.searchForm.nickname,
                    type: this.searchForm.type
                };
                this.$axios.post("admin/user_third/index", data).then((res) => {
                    this.params.totals = res.data.count;
                    this.tableData = res.data.list;
                    this.tableData.map((num) => {
                        num.bind_time = formatDate(num.bind_time);
                        num.unbind_time = formatDate(num.unbind_time)
                    })
                });
            },
            // 每页显示多少条
            changeSize(val) {
                this.params.pagesize = val;
                this.getList();
            },
            // 当前显示的页数
            changeCurrent(val) {
                this.params.pagenum = val;
                this.getList()
            },
            search() {
                this.params.pagenum = 1;
                this.getList();
            },
        }
    }
</script>

<style scoped>

</style>